import React from "react";
import SuccessResetView from "../components/SuccessReset/View";

const SuccessReset = () => <SuccessResetView />;

export default SuccessReset;
